<template>
  <DialogTemplate
    data-tst="solfigr_rakedialog"
    style="--dialog-content-overflow: none"
  >
    <RakesTables
      style="mh-0"
      @click:item="({ item }) => handleClick({ item })"
    />

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        data-tst="btn_close"
        variant="text"
        @click="close"
        >{{ $t('btn.close') }}</v-btn
      >
      <portal-target name="dialog_actions" />
    </template>
  </DialogTemplate>
</template>

<script>
import { SNK } from '@/helpers/helpers'
import RakesTables from '@/components/DataTables/v2/tables/RakesTable/RakesTables'
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import { getSolfigrFields } from '@/store/solfigr/solfigr_helpers'

export default {
  name: 'SolfigrShortcutDialog',
  components: {
    RakesTables,
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  methods: {
    handleClick({ item }) {
      const startStreet = this.$store.getters[SNK('slfrm_startStreet', this.namespace)]

      const items = [
        [`slfrm_rakePercent_${startStreet}`, item.rakePercent],
        [`slfrm_rakeCap_${startStreet}`, item.rakeCap],
        [
          `slfrm_preflopRakeType`,
          item.preflopRakeType || getSolfigrFields().preflopRakeType.default,
        ],
      ]
      items.forEach(ii =>
        this.$store.commit(SNK('slfrm_set', this.namespace), { key: ii[0], value: ii[1] }),
      )

      this.$store.dispatch(SNK('slfrm_getTreePreview', this.namespace), {
        fromStart: true,
      })
      this.close()
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'solfigr-rake-dialog')
    },
  },
  computed: {
    namespace() {
      return this.dialog.namespace || null
    },
  },
}
</script>
